// The web's half of the tour targets (shared/tour-copy.ts names them; the native build marks the
// element with `dataSet={{ tour: "<name>" }}`). Split out of Tutorial.tsx so src/tour-moments.ts
// can ask whether a card's target is on the screen without loading the tour itself.

/**
 * The CSS selector for each tour target name in shared/tour-copy.ts. A name missing here falls back
 * to `[data-tour~="<name>"]`. A step whose target never appears once its screen has loaded is
 * passed over; null is a centred card.
 */
export const SELECTORS: Record<string, string> = {
  fab: ".fab",
  "tab-done": '.tab[href="#/done"]',
  who: ".who",
  "next-up": ".next-up",
  "note-add": ".note-add",
  // The task screen: its Job's Done button and its gold line (src/views/TaskDetail.tsx).
  "job-done": '[data-tour~="job-done"]',
  coins: '[data-tour~="coins"]',
  // The account sheet's Notifications row (src/components/AccountSheet.tsx).
  notifications: '[data-tour~="notifications"]',
  "task-card": ".task-card",
  "luxury-offer": ".luxury-offer",
  "rewards-heading": ".rewards-heading",
  "tab-upgrades": '.tab[href="#/upgrades"]',
  // The character editor's tab strip (src/views/PeonEditor.tsx), with the tiles under it.
  "editor-tabs": '[data-tour~="editor-tabs"]',
};

/** A target name ("a|b": the first of either in document order) as this build's CSS selector. */
export function selectorFor(target: string): string {
  return target
    .split("|")
    .map((name) => SELECTORS[name] ?? `[data-tour~="${name}"]`)
    .join(", ");
}
